import React from 'react';

export default function UsersAdmin() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-3xl font-black text-slate-900 tracking-tight">Users Admin</h1>
      <p className="text-slate-500 mt-2">
        Manage platform roles and permissions for volunteers and staff.
      </p>

      <div className="mt-8 bg-white border border-slate-100 rounded-[2rem] p-8 shadow-sm">
        <p className="text-slate-400 italic">User management interface coming soon.</p>
      </div>
    </div>
  );
}